import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'

export const MoneyNumberFormat = (props) => {
    const { inputRef, onChange, ...other } = props

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        value: values.value,
                    },
                })
            }}
            allowNegative={false}
            // thousandSeparator
            prefix="$"
        />
    )
}

export const PhoneNumberFormat = (props) => {
    const { inputRef, onChange, ...other } = props

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        value: values.value,
                    },
                })
            }}
            allowNegative={false}
            maxLength={10}
            // thousandSeparator
        />
    )
}

export function CuitNumberFormat(props) {
    const { inputRef, onChange, ...other } = props

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        value: values.value,
                    },
                })
            }}
            placeholder="12-12345678-1"
            format={'##-########-#'}
        />
    )
}

MoneyNumberFormat.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
}

export function ReplaceQuotes(data) {
    return Object.keys(data).forEach(item => {
        var value = data[item];
        if (typeof value === 'string') {
            data[item] = value.replace(/['"]/g, " ")
        } else if (typeof value === "object" && value !== null) {
            ReplaceQuotes(value)
        }  
    })
}

// Caracteres especiales
// export function ReplaceNotAlowedCharacters(data) {
//     return Object.keys(data).forEach(item => {
//         var value = data[item];
//         if (typeof value === 'string') {
//             data[item] = value.replace(/[^\w\d,.;:+\-*/{}\[\]\(\)@]/g, " ")
//         } else if (typeof value === "object" && value !== null) {
//             ReplaceNotAlowedCharacters(value)
//         }  
//     })
// }